import app, { AppState } from "./app";

export interface RootState {
  app: AppState;
}

export default {
  app
};
